import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class SelectDetectedCompany {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) { }

  async run(company_id,doc_id): Promise<any> {
    let args = { 
      company_id: company_id,
      inv_id: doc_id
    }
    return await this.dispatcher.dispatch('manually.selected.detected.company', args)
  }
}